// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ofHl","questions":"styles_questions__3Ioxx","footer":"styles_footer__aC8Lt"};